const getters = {
  getVendorList(state) {
    return state.vendorList;
  },
  getVendor(state) {
    return state.vendor;
  },
  getInvoiceData(state) {
    return state.vendorInvoiceData;
  }
};

export default getters;
